import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NiceSelectModule } from "ng-nice-select";
import { NgxPaginationModule } from 'ngx-pagination';

import { SharedModule } from '@teem/shared/shared.module';
import { CoreModule } from '@teem/core/core.module';

import { RevenueModalComponent } from '@teem/dashboard-module/modals/revenue-modal/revenue-modal.component';
import { ExpenseModalComponent } from '@teem/dashboard-module/modals/expense-modal/expense-modal.component';
import { ProfitsModalComponent } from '@teem/dashboard-module/modals/profits-modal/profits-modal.component';
import { CircleComponent } from '@teem/dashboard-module/components/circle/circle.component';
import { StepComponent } from '@teem/dashboard-module/components/step/step.component';
import { DasboardBlockComponent } from '@teem/app/features/dashboard/components/dahboard-block/dahboard-block.component';
import { DashboardRoutingModule } from '@teem/dashboard-module/dashboard-routing.module';
import { DashboardComponent } from '@teem/dashboard-module/dashboard.component';
import { InvoiceComponent } from '@teem/app/features/dashboard/components/invoice/invoice.component';
import { PaymentHistoryComponent } from '@teem/app/features/dashboard/components/payment-history/payment-history.component';
import { CurrentOrdersComponent } from '@teem/app/features/dashboard/components/current-orders/current-orders.component';
import { OrderHistoryComponent } from '@teem/app/features/dashboard/components/order-history/order-history.component';
import { LineChartComponent } from '@teem/app/features/dashboard/components/line-chart/line-chart.component';
import { TopCustomersTableComponent } from '@teem/app/features/dashboard/components/top-customers-table/top-customers-table.component';
import { TopProductsTableComponent } from '@teem/app/features/dashboard/components/top-products-table/top-products-table.component';
import { RecentlyAddedProductsComponent } from '@teem/app/features/dashboard/components/recently-added-products/recently-added-products.component';
import { RejectionReasonComponent } from '@teem/features/dashboard/modals/rejection-reason/rejection-reason.component';
// import { CurrentOrdersComponent } from '@teem/app/features/dashboard/components/current-orders/current-orders.component';
import { BranchesModule } from '@teem/web-market/store-branches/branches.module';
import { CreateStoreModalComponent } from '@teem/features/dashboard/modals/create-store-modal/create-store-modal.component';
@NgModule({
  declarations: [
    DashboardComponent,
    RevenueModalComponent,
    ExpenseModalComponent,
    ProfitsModalComponent,
    CircleComponent,
    StepComponent,
    DasboardBlockComponent,
    InvoiceComponent,
    PaymentHistoryComponent,
    CurrentOrdersComponent,
    OrderHistoryComponent,
    LineChartComponent,
    TopCustomersTableComponent,
    TopProductsTableComponent,
    RecentlyAddedProductsComponent,
    RejectionReasonComponent,
    CreateStoreModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NiceSelectModule,
    SharedModule,
    CoreModule,
    DashboardRoutingModule,
    NgxPaginationModule,
    BranchesModule
  ]
})
export class DashboardModule { }
